import { createFileRoute } from '@tanstack/react-router';
import { JourneysManualSegmentTabHandoff } from '@/pages/workspaces/segments/[segmentId]/overview/routing';

/**
 * The `journeys` URL the segment tab bar links to for Overview. Flag off it renders the embedded host, which resolves its own `last` sentinel;
 * flag on it reads the segment and forwards a manual one to the tab's own URL, leaving any other
 * with the embedded app.
 */
function JourneysSegmentOverviewRoute() {
  const { segmentId } = Route.useParams();

  return <JourneysManualSegmentTabHandoff segmentId={segmentId} tab="overview" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/overview')({
  component: JourneysSegmentOverviewRoute,
});
